app.controller('stateOfHealthAllergyListController', ['$scope', '$state', '$mdDialog', '$translate', 'applicationModel', 'patientModel', 'allergyModel', 'userModel',
    function ($scope, $state, $mdDialog, $translate, applicationModel, patientModel, allergyModel, userModel) {

        var listeners = {};

        function setData() {
            $scope.allergies = null;
            $scope.numberOfPages = null;

            $scope.criteria = new StateOfHealthDataGridCriteria();
            $scope.criteria.idPatient = $state.params.patientId;
            $scope.currentUserId = userModel.currentUser.id;

            $scope.columns = [
                {
                    field: "type | prefix:'T.ENUM.ALLERGY_TYPE.' | translate",
                    displayName: "T.MODULE.PATIENT.TYPE"
                },
                {
                    field: "creationDate | date:\'dd.MM.yyyy\'",
                    displayName: "T.MODULE.PATIENT.ADD_DATE"
                },
                {
                    field: "notes",
                    displayName: "T.MODULE.PATIENT.NOTES"
                },
                {
                    cellTemplate: "edm/application/view/app/patient/grid-template/data-allergy-row-actions.html"
                }
            ];

            $scope.buttons = [
                {
                    icon: 'content:add',
                    action: 'addAllergy'
                },
                {
                    label: $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL'),
                    action: 'getDataPage'
                }
            ];

            $scope.showOptions = {
                all: false
            }
        }


        function setPermissions() {
        }

        function setListeners() {
            listeners.onAllergiesDataPageLoad = function(dataPage) {
                $scope.allergies = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            }
        }

        function setActions() {
            $scope.criteriaChanged = function () {
                allergyModel.getDataPage($scope.criteria).then(listeners.onAllergiesDataPageLoad);
            };

            $scope.addAllergy = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-allergy.html',
                    controller: 'popupAllergyCreateController'
                })
                    .then(function (data) {
                        $scope.getAllergiesDataPage();
                    }, function () {
                        //cancel
                    });
            };

            $scope.previewAllergy = function(allergy, previewOnly) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-allergy.html',
                    controller: 'popupAllergyUpdateController',
                    resolve: {
                        allergyToUpdate: function() {
                            return allergy;
                        },
                        preview: function() {
                            return true;
                        }
                    }
                })
                    .then(function (data) {
                        $scope.getAllergiesDataPage();
                    }, function () {
                        //cancel
                    });
            };

            $scope.deleteAllergy = function(allergy) {
                var label = $translate.instant('T.ENUM.ALLERGY_TYPE.' + allergy.type);
                if(allergy.notes) {
                    label += ' (' + allergy.notes + ')';
                }
                var configPopup = {
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                    controller: 'popupDeleteWithReasonController',
                    controllerAs: 'deleteConfirmCtrl',
                    skipHide: true,
                    locals: {
                        labels: label,
                        item: angular.copy(allergy),
                        userModel: userModel,
                        $mdDialog: $mdDialog,
                        message: 'T.MODULE.PATIENT.ALLERGY_DELETE_CONFIRMATION'
                    }
                };

                $mdDialog.show(configPopup).then(function(data) {
                    allergyModel.update(data).then(function() {
                        $scope.getAllergiesDataPage();
                    });
                });
            };

            $scope.changeButtonLabel = function() {
                if($scope.showOptions.all) {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ACTIVE_ONLY');
                } else {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL');
                }
            };

            $scope.getAllergiesDataPage = function(changeButton) {
                if(changeButton) {
                    $scope.showOptions.all = !$scope.showOptions.all;
                    $scope.changeButtonLabel();
                }
                if(!$scope.showOptions.all) {
                    if($scope.criteria.allowDeleted) {
                        delete $scope.criteria.allowDeleted;
                    }
                } else {
                    if(!$scope.criteria.allowDeleted) {
                        $scope.criteria.allowDeleted = true;
                    }
                }
                allergyModel.getDataPage($scope.criteria).then(listeners.onAllergiesDataPageLoad);
            };

            $scope.getDataPage = function() {
                $scope.getAllergiesDataPage(true);
            };

            $scope.userHasAccessToDeleteEntity = function(entity) {
                return entity.author.id === $scope.currentUserId || (entity.author.userType === 'MEDICAL_OFFICE' && userModel.currentUser.userType === Enum.USER_TYPE.DOCTOR);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            $scope.getAllergiesDataPage();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
